import { useEffect, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import { useDispatch } from "react-redux";
import MobileLeftSection from "../../Components/MobileLeftSection";
import { AiFillSafetyCertificate } from "react-icons/ai";

export default function MobileCart({
  DetailsPack,
  Login_User,
  handleRemove,
  CartDetails,
  OrderData,
  successCapply,
  Coupon,
  setCoupon,
  loadingCapply,
  COUPON_APPLY_RESET,
  handleCouponApply,
  errorCapply,
  AcceptTerms,
  setTermsVisible,
  Package_Timing,
  handlePlaceOder,
  loadingOrder,
  errorOrder,
}) {
  const [SideOpener, setSideOpner] = useState(false);
  const dispatch = useDispatch();
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {" "}
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="Cart" />
        <div className="main-content">
          <MobileHeaderSection Page="My Cart" OpenSideMenu={OpenSideMenu} />
          <section className="CartMargin">
            <div className="Cart_section">
              <div className="CartSection1">
                <div style={{ background: "#2C3F8C" }}>
                  <h4> CART DETAILS </h4>
                </div>
                {DetailsPack ? (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h4>{DetailsPack?.PackageId?.Name}</h4>
                      {Login_User ? (
                        <div>
                          <button
                            onClick={() => handleRemove(CartDetails[0]?._id)}
                            className="rmv_btn"
                          >
                            REMOVE
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <p
                      style={{
                        fontSize: "14px",
                        margin: "0",
                        padding: "2px 0 4px 0",
                      }}
                    >
                      {DetailsPack?.PackageId?.Detail}
                    </p>
                    <p
                      style={{
                        fontSize: "15px",
                        margin: "0",
                        padding: "2px 0",
                        fontWeight: "600",
                      }}
                    >
                      Duration: {DetailsPack?.PackageId?.Duration} Weeks
                    </p>
                    <hr />
                    <div>
                      <p>
                        <strong>This package Includes : </strong>
                      </p>
                      <div className={"SpeakingWriting"}>
                        {DetailsPack?.LIVE_CLASSES ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_LIVE_CLASSES.svg"
                                alt="icon_LIVE_CLASSES"
                              />
                            </span>
                            <span>
                              {DetailsPack?.LIVE_CLASSES} LIVE CLASSES{" "}
                            </span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.One_On_One_DOUBT_SESSIONS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
                                alt="icon_LIVE_CLASSES"
                              />
                            </span>
                            <span>1:1 DOUBT SESSIONS </span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.DOUBT_SESSIONS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_DOUBT_SESSIONS.svg"
                                alt="icon_LIVE_CLASSES"
                              />
                            </span>
                            <span> DOUBT SESSIONS</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.SESSION_TESTS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_SESSION_TESTS.svg"
                                alt="icon_SESSION_TESTS"
                              />
                            </span>
                            <span>SESSION TESTS </span>
                          </p>
                        ) : (
                          ""
                        )}
                        {DetailsPack?.STUDY_MATERIAL_ACCESS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_STUDY_MATERIAL_ACCESS.svg"
                                alt="icon_STUDY_MATERIAL_ACCESS"
                              />
                            </span>
                            <span> STUDY MATERIAL ACCESS</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.COMPLETE_MOCK_TEST ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_MOCK_TEST.svg"
                                alt="icon_MOCK_TEST"
                              />
                            </span>
                            <span>
                              {DetailsPack?.COMPLETE_MOCK_TEST} COMPLETE MOCK
                              TEST
                            </span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.COMPLETE_MOCK_TEST_AI ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_MOCK_TEST_AI.svg"
                                alt="icon_MOCK_TEST"
                              />
                            </span>
                            <span>
                              {DetailsPack?.COMPLETE_MOCK_TEST_AI} COMPLETE MOCK
                              TEST (POWERED BY AI)
                            </span>
                          </p>
                        ) : (
                          ""
                        )}
                        {DetailsPack?.TESTIFYI_REALITY_TEST ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_reality_test.svg"
                                alt="icon_reality_test"
                              />
                            </span>
                            <span>
                              {DetailsPack?.TESTIFYI_REALITY_TEST} TESTIFYI
                              REALITY TEST
                            </span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.MASTER_CLASS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_Master_class.svg"
                                alt="icon_Master_class"
                              />
                            </span>
                            <span> MASTER CLASS</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.One_On_One_SPEAKING_SESSIONS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_Speaking_Session.svg"
                                alt="icon_Speaking_Session"
                              />
                            </span>
                            <span>1:1 SPEAKING SESSIONS</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.LANGUAGE_PRACTICE_TEST ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_LANGUAGE_PRACTICE_TEST.svg"
                                alt="icon_LANGUAGE_PRACTICE_TEST"
                              />
                            </span>
                            <span>
                              {DetailsPack?.LANGUAGE_PRACTICE_TEST} TESTIFYI
                              PRACTICE TEST
                            </span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.GRAMMAR_TEST === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_GRAMMAR_TEST.svg"
                                alt="icon_GRAMMAR_TEST"
                              />
                            </span>
                            <span>GRAMMAR TEST</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.MOCK_INTERVIEW === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_Mock_INTERVIEW.svg"
                                alt="icon_Mock_INTERVIEW"
                              />
                            </span>
                            <span>MOCK INTERVIEW</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.GROUP_DISCUSSIONS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_GROUP_DISCUSSIONS.svg"
                                alt="icon_GROUP_DISCUSSIONS"
                              />
                            </span>
                            <span>GROUP DISCUSSIONS</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.BUSINESS_ENGLISH_SESSIONS === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_BUSINESS_ENGLISH_SESSIONS.svg"
                                alt="icon_BUSINESS_ENGLISH_SESSIONS"
                              />
                            </span>
                            <span>BUSINESS ENGLISH SESSIONS</span>
                          </p>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.SOFT_SKILLS_SESSION === "Yes" ? (
                          <p>
                            <span>
                              <img
                                src="/assets/image/ProductCard-Icon/icon_SOFT_SKILLS_SESSION.svg"
                                alt="icon_SOFT_SKILLS_SESSION"
                              />
                            </span>
                            <span>SOFT SKILLS SESSION</span>
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <h4>Empty Cart</h4>
                    {/* <p>
                  search courses  <button className="custom_btn"></button>
                </p> */}
                  </div>
                )}
              </div>

              <div>
                <div className="Price_Det_Cart">
                  <div>
                    <h4>PRICE DETAILS</h4>
                  </div>
                  {DetailsPack ? (
                    <div>
                      <div className="Prices">
                        <p>Price</p>
                        <p>₹ {DetailsPack?.PackageId?.ActualCost}</p>
                      </div>
                      {OrderData?.AmountDiscounted ? (
                        <div className="Prices">
                          <p> Discount for you</p>
                          <p style={{ color: "green" }}>
                            -{OrderData?.AmountDiscounted}
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                      <div>
                        <hr className="dotted" />
                      </div>

                      <div className="Prices">
                        <h5>Total Amount</h5>
                        <h5>₹ {OrderData?.amount}</h5>
                      </div>

                      <div>
                        <hr className="dotted" />
                      </div>

                      <div>
                        {OrderData?.AmountDiscounted ? (
                          <h6
                            style={{
                              color: "green",
                              padding: "0",
                              margin: "0",
                              marginBottom: DetailsPack?.PackageId?.isVisible
                                ? 0
                                : "5px",
                            }}
                          >
                            You will save{" "}
                            {OrderData.AmountDiscounted
                              ? OrderData.AmountDiscounted
                              : 0}{" "}
                            on this order.{" "}
                          </h6>
                        ) : (
                          ""
                        )}

                        {DetailsPack?.PackageId?.isVisible ? (
                          <div className="Coupon_Apply">
                            <input
                              placeholder="APPLY COUPON"
                              disabled={successCapply}
                              value={Coupon}
                              onChange={(e) =>
                                setCoupon(e.target.value?.toUpperCase())
                              }
                            />
                            {successCapply ? (
                              <button
                                className="RemoveC"
                                loading={loadingCapply}
                                disabled={loadingCapply}
                                onClick={() => {
                                  dispatch({ type: COUPON_APPLY_RESET });
                                  setCoupon("");
                                }}
                              >
                                REMOVE
                              </button>
                            ) : (
                              <button
                                style={{ background: "#2C3F8C" }}
                                loading={loadingCapply}
                                disabled={loadingCapply}
                                onClick={() => handleCouponApply()}
                              >
                                APPLY
                              </button>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {errorCapply ? (
                          <p
                            style={{
                              color: "red",
                              padding: "0 15px 10px 15px",
                              textAlign: "center",
                            }}
                          >
                            {errorCapply}
                          </p>
                        ) : (
                          ""
                        )}

                        {successCapply ? (
                          <p
                            style={{
                              color: "green",
                              padding: "0 15px 10px 15px",
                              textAlign: "center",
                              fontWeight: "700",
                            }}
                          >
                            Coupon Applied Successfully !
                          </p>
                        ) : (
                          ""
                        )}
                        <h6
                          style={{
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            padding: "0",

                            margin: DetailsPack?.PackageId?.isVisible
                              ? 0
                              : "8px 0",
                          }}
                        >
                          <span>
                            <input
                              type="checkbox"
                              checked={AcceptTerms}
                              onClick={() => setTermsVisible(true)}
                              required
                            />
                          </span>
                          <span>I Agree with the Terms & Conditions *</span>
                        </h6>
                        {Package_Timing?.CustomTimings ? (
                          <h6 style={{ color: "blue" }}>
                            We have received your request and our team will get
                            back to you.
                          </h6>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="Prices">
                        <p>Price</p>
                        <p>₹ 0</p>
                      </div>
                      <div className="Prices">
                        <p> Discount for you</p>
                        <p style={{ color: "green" }}>- 0</p>
                      </div>
                      <div>
                        <hr className="dotted" />
                      </div>

                      <div className="Prices">
                        <h5>Total Amount</h5>
                        <h5>₹ 0</h5>
                      </div>

                      <div>
                        <hr className="dotted" />
                      </div>

                      <div>
                        {/* <h6 style={{ color: "green" }}>
                  You will save{" "}
                  {+DetailsPack?.PackageId?.ActualCost -
                    +DetailsPack?.PackageId?.DiscountedPrice}{" "}
                  on this order.{" "}
                </h6> */}
                      </div>
                    </div>
                  )}

                  <div className="PlaceOrder">
                    {Package_Timing?.CustomTimings ? (
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          justifyContent: "center",
                          background: "#2C3F8C",
                        }}
                        href="tel:+919289192873"
                        className="custom_btn"
                      >
                        Call Now
                      </a>
                    ) : window.innerWidth <= 481 ? (
                      <button
                        style={{ background: "#2C3F8C" }}
                        disabled={true}
                        // onClick={() => handlePlaceOder()}
                        className="custom_btn"
                      >
                        {loadingOrder ? "Loading..." : "ORDER ON WEBSITE"}
                      </button>
                    ) : (
                      <button
                        style={{ background: "#2C3F8C" }}
                        disabled={!DetailsPack || loadingCapply}
                        onClick={() => handlePlaceOder()}
                        className="custom_btn"
                      >
                        {loadingOrder ? "Loading..." : "PLACE ORDER"}
                      </button>
                    )}
                  </div>
                </div>

                {errorOrder ? (
                  <p
                    style={{
                      color: "red",
                      padding: "0 15px 10px 15px",
                      textAlign: "center",
                      fontSize: "13px",
                    }}
                  >
                    {errorOrder}
                  </p>
                ) : (
                  ""
                )}

                <div className="Safe_Secure">
                  <p>
                    <span>
                      <AiFillSafetyCertificate />
                    </span>
                    <span>Safe and Secure Payments 100%.</span>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <MobileBottomMenu Page="Cart" />
        </div>
      </div>
    </>
  );
}
